import type { ReactNode } from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';
type BadgeSize = 'sm' | 'md';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
}

export default function Badge({ children, variant = 'default', size = 'sm', className = '' }: BadgeProps) {
  const base = 'inline-flex items-center rounded-full border font-medium';

  const sizes: Record<BadgeSize, string> = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  };

  const variants: Record<BadgeVariant, string> = {
    default: 'bg-background-subtle/50 border-border text-text-body',
    info: 'bg-primary/10 border-primary/20 text-primary',
    success: 'bg-success-bg border-success/20 text-success',
    warning: 'bg-warning-bg border-warning/20 text-warning',
    danger: 'bg-danger-bg border-danger/20 text-danger',
  };

  return <span className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}>{children}</span>;
}
